import FullCalendar, { EventContentArg } from "@fullcalendar/react";

import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import { LiveKitRoom } from "@livekit/components-react";
import axios from "axios";
import { add, format } from "date-fns";
import { Fragment, useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { useProviderAuthState } from "../../api/hooks/provider/auth/useProviderAuthState";
import { useBookProviderAppointments } from "../../api/hooks/provider/useBookProviderAppointments";
import { useCancelAppointment } from "../../api/hooks/provider/useCancelAppointment";
import { useGetPatientFormResponse } from "../../api/hooks/provider/useGetPatientResponse";
import { useGetProviderPreviousAppointments } from "../../api/hooks/provider/useGetPreviousProviderApointments";
import { useGetProviderForm } from "../../api/hooks/provider/useGetProviderForm";
import { useGetPatientUpcomingAppointments } from "../../api/hooks/provider/useGetProviderUpcomingAppointsments";
import { useGetSinglePatientRecord } from "../../api/hooks/provider/useGetSinglePatientRecord";
import { useSaveChargeSheetDraft } from "../../api/hooks/provider/useSaveChargeSheet";
import { useSaveFormResponse } from "../../api/hooks/provider/useSaveFormResponse";
import { useSendChargeSheetToBilling } from "../../api/hooks/provider/useSendChargeSheetToBilling";
import FormBuilder from "../../components/form/FormBuilder";
import { usePostMeeting } from "../../components/meetings/hooks/postMeeting";
import BtnButton from "../../components/shared/BtnButton";
import ListTabsWidget from "../../components/shared/ListTabsWidget";
import { Loading } from "../../components/shared/Loading";
import { removeZerosAndCheckAMPM, truncateText } from "../../utils/helpers";
import { useStripeCardDetails } from "../../hooks/useStripeCardDetails";
import { SimpleChargeSheetModal } from "../components/SimpleModal";
import MobileAppointmentCard from "../components/appointments/MobileAppointmentCard";
import NewAppointmentModal, {
  AppointmentWithClientProps
} from "../components/appointments/NewAppointmentModal";
import ProviderAppointmentsDrawer from "../components/appointments/ProviderAppointmentDrawer";
import RescheduleAppointmentModal from "../components/appointments/RescheduleAppointment";
import ProviderDashboardLayout from "../components/dashboard/ProviderDashboardLayout";
import { NoteValue } from "./PatientDetail/interfaces";
import http from "../../utils/http";
import { useCardDetails } from "../../context/CardDetailsContext";
import { Playicon } from "../../svgs/PlayIcon";
import Button from "../../components/shared/Button";
import ModalPortal from "../../components/shared/ModalPortal";
import { CancelIcon } from "../../svgs/CancelIcon";
import { useStartAwsScribe } from "../components/hooks/use_aws_scribe";
import { ChargesModal } from "../../components/meetings/ChargesModal";
import { TempleLiveKitMeeting } from "../../components/meetings/TempleLiveKitMeeting";

const Appointments = () => {
  const { user } = useProviderAuthState();
  const [activeTabLabel, setActiveTabLabel] = useState("Upcoming");
  const [activeVideoTabLabel, setActiveVideoTabLabel] = useState("Intake Form");
  const [joinCall, setJoinCall] = useState(false);
  const [showNewAppointmentModal, setShowNewAppointmentModal] = useState(false);
  const [appointmentInfo, setAppointmentInfo] = useState<any | null>(null);
  const [openAppointmentDetails, setOpenAppointmentDetails] = useState(false);
  const [providersUpcomingAppointments, setProvidersUpcomingAppointments] =
    useState<any>(null);
  const [providersPreviousAppointments, setProvidersPreviousAppointment] =
    useState<any>(null);
  const [isRescheduleViewVisible, setIsRescheduleViewVisible] = useState(false);
  const [showChargeSheetModal, setShowChargeSheetModal] = useState(false);
  const [showMeetingCostModal, setshowMeetingCostModal] =
    useState<boolean>(false);
  const [oldAppointmentForReschedule, setOldAppointmentForReschedule] =
    useState<string>("");
  const [providerId, setProviderId] = useState<string>("");
  const [appointmentObject, setAppointmentObject] = useState<any>({});
  const [noteFields, setNoteFields] = useState<NoteValue>({});
  const [didCallEnd, setDidCallEnd] = useState<boolean>(false);
  const [appointmentId, setAppointmentId] = useState<string>("");
  const [noteGenerationStatus, setNoteGenerationStatus] = useState<"ai-generation" | "manual">("manual");
  const [showAIPricingModal, setShowAIPricingModal] = useState(false);
  const [fileName, setFileName] = useState<any>(null);

  const { setHasAddedCard } = useCardDetails();

  // Stripe card details React Query logic
  const {
    isChecking,
    error: stripeError,
    customerId,
    hasSavedCard,
    isCreatingCustomer,
    isCheckingCards
  } = useStripeCardDetails({
    stripeCustomerId: user?.stripeCustomerId ?? undefined,
    setHasAddedCard,
  });

    const { startAwsScribe } = useStartAwsScribe()


  const handleTabClick = (tabName: string) => {
    setActiveTabLabel(tabName);
  };

  const handleVideoTabClick = (tabName: string) => {
    setActiveVideoTabLabel(tabName);
  };

  const {
    refetchPatientFormResponse,
    patientFormResponseData,
    isLoading: isPatientFormLoading
  } = useGetPatientFormResponse({
    appointmentId
  });


  const { bookAppointmentsForProvider, isPending: isBooking } =
    useBookProviderAppointments();

  const handleProviderScheduleAppointment = (
    values: AppointmentWithClientProps
  ) => {
    bookAppointmentsForProvider({
      patientId: values.patientId,
      appointmentDate: values.appointmentDate,
      appointmentStartTime: values.appointmentStartTime,
      isInitialAppointment: values.isInitialAppointment,
      appointmentType: values.appointmentType
    });
    setShowNewAppointmentModal(false);
  };



  useEffect(() => {
    if (appointmentId) {
      refetchPatientFormResponse();
    }
  }, [appointmentId]);

  const { providerFormData } = useGetProviderForm({
    formType: appointmentInfo?.isInitialAppointment
      ? ["initialVisitNote"]
      : ["progressNote"],
    providerId: user?.userId ? user?.userId : ""
  });


  const {
    data,
    error: formError,
    isError: isFormError,
    isLoading: isFormLoading
  } = providerFormData[0];

  if (isFormError && axios.isAxiosError(formError)) {
    toast.error(data?.error?.error, { toastId: "customId" });
  } else if (data?.error !== null) {
    toast.error(data?.error, { toastId: "customId" });
  } else {
    toast.error(data?.error?.error || "Error fetching provider's form data", {
      toastId: "customId"
    });
  }

  if (!isFormLoading) {
    <div className="fixed inset-0 z-[10000000] backdrop-blur-sm flex justify-center w-full h-screen items-center">
      <Loading />
    </div>;
  }

  // TODO: review where saveFormResponse called from 373
  const { saveFormResponse } = useSaveFormResponse();
  const { saveChargeSheet, isPending: isSavingDraft } =
    useSaveChargeSheetDraft();
  const { postChargeSheetToBilling, isPending: isSendingToBilling } =
    useSendChargeSheetToBilling();

  const transformAppointments = (appointments: any[]): any => {
    return appointments.map(appointment => {
      const { appointmentDate, appointmentStartTime, appointmentEndTime } =
        appointment;
      const composeStartDate = add(new Date(appointmentDate), {
        hours: Number(appointmentStartTime.slice(0, 2)),
        minutes: Number(appointmentStartTime.slice(3, 5))
      });
      const formatStartDate = format(composeStartDate, "yyyy-MM-dd HH:mm:ss");
      const formatStartDateWithSlash = format(composeStartDate, "yyyy/MM/dd");
      const composeEndDate = add(new Date(appointmentDate), {
        hours: Number(appointmentEndTime.slice(0, 2)),
        minutes: Number(appointmentEndTime.slice(3, 5))
      });
      const formatEndDate = format(composeEndDate, "HH:mm:ss");
      const [date, time] = formatStartDate.split(" ");
      return {
        id: appointment.appointmentId,
        title: `Call with ${appointment.patientName}`,
        start: `${date}T00:00:00`,
        slotDuration: time,
        appointmentObject: {
          ...appointment,
          appointmentDate: date,
          appointmentNewDate: formatStartDateWithSlash,
          appointmentStartTime: time,
          appointmentEndTime: formatEndDate
        }
      };
    });
  };

  const { providerAppointments, isLoading, isError, error } =
    useGetPatientUpcomingAppointments();
  const {
    providerPrevAppointments,
    isLoadingPrevAptmnt,
    isErrorPrevAptmnt,
    errorPrevAptmnt
  } = useGetProviderPreviousAppointments();

  if (isErrorPrevAptmnt) {
    toast.error(
      axios.isAxiosError(errorPrevAptmnt)
        ? errorPrevAptmnt?.response?.data?.error
        : "Error getting provider's previous appointments, try again",
      { toastId: "customId" }
    );
  }

  if (isError) {
    toast.error(
      axios.isAxiosError(error)
        ? error?.response?.data?.error
        : "Error getting provider's upcoming appointments, try again",
      { toastId: "customId" }
    );
  }

  useEffect(() => {
    if (
      !isLoadingPrevAptmnt &&
      providerPrevAppointments?.previousAppointments
    ) {
      const transformedAppointments = transformAppointments(
        providerPrevAppointments?.previousAppointments
      );
      setProvidersPreviousAppointment(transformedAppointments);
    }
  }, [providerPrevAppointments?.previousAppointments, isLoadingPrevAptmnt]);

  useEffect(() => {
    if (!isLoading && providerAppointments?.providersUpcomingAppointments) {
      const transformedAppointments = transformAppointments(
        providerAppointments?.providersUpcomingAppointments
      );
      setProvidersUpcomingAppointments(transformedAppointments);
    }
  }, [providerAppointments?.providersUpcomingAppointments, isLoading]);

  const { cancelAppointment } = useCancelAppointment();

  function renderEventContent(eventContent: EventContentArg) {
    const {
      title,
      extendedProps: { slotDuration, appointmentObject }
    } = eventContent?.event?._def;
    return (
      <div
        className=""
        onClick={() => {
          if (appointmentObject) {
            setAppointmentInfo(appointmentObject);
            setAppointmentId(appointmentObject?.appointmentId);
            providerFormData[0].refetch();
          }
          setOpenAppointmentDetails(true);
          // refetchPatientFormResponse();
        }}
      >
        <i className="text-xs">{truncateText(title, 20)}</i>
        <p className="text-xs">{removeZerosAndCheckAMPM(slotDuration)}</p>
      </div>
    );
  }

  useEffect(() => {
    if (appointmentInfo) {
      setAppointmentObject(appointmentInfo);
    }
  }, [appointmentInfo]);

  useEffect(() => {
    if (didCallEnd) {
      setJoinCall(false);
      // setShowChargeSheetModal(true);
      setshowMeetingCostModal(true)
      setDidCallEnd(false);
      setOpenAppointmentDetails(false);
    }
  }, [didCallEnd]);

  const handleCloseMeetingCostModal = () => {
    setshowMeetingCostModal(false);
    setShowChargeSheetModal(true);
  }

  const { data: patientData } = useGetSinglePatientRecord(
    appointmentObject?.patientId
  );

  const fullPatientData = useMemo(() => {
    return {
      appointmentId,
      patientName: `${patientData?.patientDetails.patient.firstName}${" "}${patientData?.patientDetails.patient.lastName}`,
      providerId: patientData?.patientDetails.patient?.userId,
      dateOfBirth: patientData?.patientDetails.patient.dateOfBirth,
      gender: patientData?.patientDetails.patient.gender,
      patientId: patientData?.patientDetails.patient.userId,
      insurance: patientData?.patientDetails.patient.insuranceName,
      modeOfEncounter: appointmentInfo?.appointmentType as
        | "virtual"
        | "physical",
      dateOfEncounter: appointmentInfo?.appointmentDate as string
    };
  }, [patientData, appointmentObject, appointmentInfo, appointmentId]);

  const { postMeeting, isPending, data: meetingResponse } = usePostMeeting();


  if (providerFormData[0].isLoading || isPending) {
    <div className="fixed inset-0 z-[10000000] backdrop-blur-sm flex justify-center w-full h-screen items-center">
      <Loading />
    </div>;
  }

  return (
    <>
      {joinCall ? (
        <div className="h-full flex items-center">
          <TempleLiveKitMeeting
            appointmentId={appointmentId}
            liveKitResponse={meetingResponse}
            setDidCallEnd={setDidCallEnd}
            patientName={`${patientData?.patientDetails.patient.firstName}` || ""}
            setNoteGenerationStatus={setNoteGenerationStatus}
            setFileName={setFileName}

          />
          <div className="w-[40%] h-full px-4 py-5">
            <div className="overflow-y-hidden mb-6 px-4 w-full overflow-x-scroll lg:overflow-x-hidden py-4">
              <ListTabsWidget
                tabs={[{ label: "Intake Form" }, { label: "Notes" }]}
                handleTabClick={label => {
                  handleVideoTabClick(label);
                }}
                activeTabLabel={activeVideoTabLabel}
              />
            </div>

            {isPatientFormLoading ? (
              <div className="flex justify-center items-center h-1/2">
                <Loading />
              </div>
            ) : (
              <Fragment>
                {activeVideoTabLabel === "Intake Form" && (
                  <div className="w-full h-fit overflow-y-auto">
                    <div className="w-full flex justify-between items-center mb-6">
                      <p>
                        Intake form answers: {`${appointmentInfo?.patientName}`}
                      </p>
                    </div>
                    {patientFormResponseData?.formResponse.values?.length ? (
                      <div className="w-full h-full">
                        {patientFormResponseData?.formResponse.values?.map(
                          (item: any, idx: number) => (
                            <section key={idx} className="text-[18px]">
                              {Object.entries(item).map(([key, value]: any) => (
                                <div className="w-full pb-5" key={key}>
                                  <p className="font-semibold">{key}</p>
                                  {Array.isArray(value) ? (
                                    Object.keys(value[0])?.map(
                                      (item: any, index) => (
                                        <div key={index}>
                                          <input
                                            className="accent-[#3D874E]"
                                            type="checkbox"
                                            checked={value[0][item]}
                                            readOnly={true}
                                          />{" "}
                                          <span>{item}</span>
                                        </div>
                                      )
                                    )
                                  ) : (
                                    <p>{value}</p>
                                  )}
                                </div>
                              ))}
                            </section>
                          )
                        )}
                      </div>
                    ) : (
                      <div className="w-full h-full">
                        {patientFormResponseData?.message}
                      </div>
                    )}
                  </div>
                )}

                {activeVideoTabLabel === "Notes" && (
                  <Fragment>
                    {data?.initialVisitNote?.noteFields?.length ||
                      data?.progressNote?.noteFields?.length > 0 ? (
                      <div className="w-full h-full overflow-y-auto">

                        {noteGenerationStatus === "ai-generation" && (
                          <div className="flex flex-col justify-center items-center">
                            <div className="w-full flex justify-start items-center text-pretty  mb-12">
                              <p>
                                Progress Note: {`${appointmentInfo?.patientName}`}
                              </p>
                            </div>
                            <div className="flex justify-center items-center w-full md:w-[450px] h-[250px] shadow-md bg-white rounded-[16px] border-box text-pretty">

                              <div className="flex flex-col px-2 py-2 text-pretty justify-center items-center">
                                <div className="w-full flex gap-3 justify-center items-center pb-10">
                                  <Playicon width={35} height={35} />
                                  <p>
                                    {`${appointmentInfo?.patientName}'s Progress Note`}
                                  </p>
                                </div>
                                <Button
                                  variant="primary"
                                  textColor="main"
                                  label="Generate documentation"
                                  onClick={() => {
                                    setShowAIPricingModal(true)
                                  }
                                  }
                                  size="large"
                                  additionalClassname="bg-[#3D874E] text-white rounded-lg px-4 py-2 text-pretty"
                                />
                              </div>
                            </div>
                          </div>
                        )}


                        {noteGenerationStatus === "manual" && (
                          <div className="w-full h-full">
                            <p
                              className="pb-5 text-primary-900 text-lg cursor-pointer text-center underline"
                              onClick={() =>
                                setNoteGenerationStatus("ai-generation")
                              }
                            >
                              Switch back to AI Generation?
                            </p>
                            {/* <div className="w-full flex justify-between items-center mb-12">
                              <p>
                                Progress Note: {`${appointmentInfo?.patientName}`}
                              </p>
                            </div> */}
                            <FormBuilder
                              formParams={
                                data?.progressNote?.noteFields ||
                                data?.initialVisitNote?.noteFields ||
                                []
                              }
                              formType={
                                appointmentInfo?.isInitialAppointment
                                  ? "initialVisitNote"
                                  : "progressNote"
                              }
                              submitAction={() => {
                                saveFormResponse({
                                  noteType: appointmentInfo?.isInitialAppointment
                                    ? "initialVisitNote"
                                    : "progressNote",
                                  noteFields: [noteFields],
                                  appointmentId: appointmentId ?? "",
                                  patientId: appointmentInfo?.patientId ?? ""
                                });
                              }}
                              isPreview={false}
                              formAnswers={noteFields}
                              setFormAnswers={setNoteFields}
                            />
                          </div>
                        )}
                      </div>
                    ) : (
                      <div>No notes!</div>
                    )}
                  </Fragment>
                )}
              </Fragment>
            )}
          </div>
        </div>
      ) : (
        <ProviderDashboardLayout headerTitle="Appointments">
          <Fragment>
            <div
              className="w-full lg:mt-8 mb-4 flex justify-end"
              data-testid="appointment-container"
            >
              <div
                className="w-full lg:w-[300px]"
                data-testid="appointment-button-container"
              >
                <BtnButton
                  type="button"
                  variant="primary"
                  label="Add Appointment"
                  onClick={() => {
                    setShowNewAppointmentModal(true);
                  }}
                  size="large"
                />
              </div>
            </div>

            <div className="w-full my-4">
              <div className="overflow-y-hidden mb-6 px-4 w-full overflow-x-scroll lg:overflow-x-hidden py-4">
                <ListTabsWidget
                  tabs={[{ label: "Past" }, { label: "Upcoming" }]}
                  handleTabClick={label => {
                    handleTabClick(label);
                  }}
                  activeTabLabel={activeTabLabel}
                />
              </div>
            </div>

            {activeTabLabel === "Past" && (
              <div className="mt-8 hidden lg:block">
                <FullCalendar
                  plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                  initialView="dayGridMonth"
                  editable={true}
                  selectable={true}
                  eventContent={renderEventContent}
                  events={providersPreviousAppointments}
                  dayMaxEventRows={1}
                  dayMaxEvents={1}
                  headerToolbar={{
                    left: "title,prev,next",
                    center: "",
                    right: ""
                  }}
                />
              </div>
            )}

            {activeTabLabel === "Upcoming" && (
              <div className="mt-8 hidden lg:block">
                <FullCalendar
                  plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                  initialView="dayGridMonth"
                  editable={true}
                  selectable={true}
                  eventContent={renderEventContent}
                  events={providersUpcomingAppointments}
                  dayMaxEventRows={1}
                  dayMaxEvents={1}
                  headerToolbar={{
                    left: "title,prev,next",
                    center: "",
                    right: ""
                  }}
                />
              </div>
            )}

            {activeTabLabel === "Past" && (
              <div className="w-full block lg:hidden lg:mt-8">
                {providersPreviousAppointments &&
                  providersPreviousAppointments?.map(
                    (item: any, index: number) => {
                      return (
                        <MobileAppointmentCard
                          key={index}
                          appointmentDetails={item?.appointmentObject}
                          onClick={() => {
                            if (item?.appointmentObject) {
                              setAppointmentInfo(item?.appointmentObject);
                              setAppointmentId(item?.appointmentObject?.appointmentId);
                            }
                            setOpenAppointmentDetails(true);
                          }}
                        />
                      );
                    }
                  )}
              </div>
            )}

            {activeTabLabel === "Upcoming" && (
              <div className="w-full block lg:hidden lg:mt-8">
                {providersUpcomingAppointments &&
                  providersUpcomingAppointments?.map(
                    (item: any, index: number) => {
                      return (
                        <MobileAppointmentCard
                          key={index}
                          appointmentDetails={item?.appointmentObject}
                          onClick={() => {
                            if (item?.appointmentObject) {
                              setAppointmentInfo(item?.appointmentObject);
                              setAppointmentId(item?.appointmentObject?.appointmentId);
                            }
                            setOpenAppointmentDetails(true);
                          }}
                        />
                      );
                    }
                  )}
              </div>
            )}
            <ProviderAppointmentsDrawer
              setOldAppointmentForReschedule={setOldAppointmentForReschedule}
              setIsRescheduleViewVisible={setIsRescheduleViewVisible}
              open={openAppointmentDetails}
              onClose={() => {
                setOpenAppointmentDetails(false);
              }}
              drawerTitle="Appointment Details"
              appointmentDetails={appointmentInfo && appointmentInfo}
              patientIntakeFormResponse={
                patientFormResponseData && patientFormResponseData.formResponse
              }
              clickJoinCall={() => {
                postMeeting({ appointmentId })
                setJoinCall(true);
                setOpenAppointmentDetails(false);
              }}
              handleCancelAppointment={() => {
                cancelAppointment({
                  appointmentId
                });
                setOpenAppointmentDetails(false);
                setAppointmentObject(null);
              }}
            />
          </Fragment>
        </ProviderDashboardLayout>
      )}
      <NewAppointmentModal
        loading={isBooking}
        isVisible={showNewAppointmentModal}
        closeModal={() => setShowNewAppointmentModal(false)}
        addAppointmentAction={handleProviderScheduleAppointment}
      />
      <RescheduleAppointmentModal
        isVisible={isRescheduleViewVisible}
        closeModal={() => setIsRescheduleViewVisible(false)}
        oldId={oldAppointmentForReschedule}
      />
      {showChargeSheetModal && (
        <div className="w-full h-[90%] lg:max-w-[90%] max-w-[95%] flex items-center justify-center border-box">
          <div className="w-full h-[90%] lg:max-w-[90%] max-w-[95%] my-8 mx-4 overflow-y-scroll rounded-tl-[16px]">
            <SimpleChargeSheetModal
              chargeSheetData={fullPatientData}
              isFromNewBilling={false}
              isSendingToBilling={isSendingToBilling}
              isSavingDraft={isSavingDraft}
              open={showChargeSheetModal}
              setOpen={setShowChargeSheetModal}
              saveAction={({
                patientId,
                appointmentId,
                procedureCodes,
                diagnosisCodes,
                modeOfEncounter,
                locationOfEncounter,
                dateOfEncounter
              }) => {
                saveChargeSheet({
                  patientId,
                  appointmentId,
                  procedureCodes,
                  diagnosisCodes,
                  status: "draft",
                  modeOfEncounter,
                  locationOfEncounter,
                  dateOfEncounter
                });
                setShowChargeSheetModal(false);
              }}
              sendToBillingAction={({
                patientId,
                appointmentId,
                procedureCodes,
                diagnosisCodes,
                modeOfEncounter,
                locationOfEncounter,
                dateOfEncounter
              }) => {
                postChargeSheetToBilling({
                  patientId,
                  appointmentId,
                  procedureCodes,
                  diagnosisCodes,
                  status: "processing",
                  modeOfEncounter,
                  locationOfEncounter,
                  dateOfEncounter
                });
                setShowChargeSheetModal(false);

              }}
            />
          </div>
        </div>
      )}

      {showMeetingCostModal && (<ChargesModal isVisible={showMeetingCostModal} appointmentInfo={appointmentInfo} onClose={handleCloseMeetingCostModal} appointmentId={appointmentId} />)}


      {showAIPricingModal && (
        <ModalPortal>
          <div
            style={{
              backgroundColor: "rgba(38, 38, 38, 0.75)",
              zIndex: 100,
              display: "flex",
              justifyContent: "center"
            }}
            className="w-screen h-screen fixed flex flex-col justify-center items-center top-0 bg-opacity-20 backdrop-blur-[5px]"
          >
            <div className="flex justify-end  w-[90%] lg:w-[462px] mx-auto py-2">
              <div
                onClick={() => {
                  setShowAIPricingModal(false);
                }}
                className="p-2 bg-white rounded-full cursor-pointer"
              >
                <CancelIcon className="h-full w-full" />
              </div>
            </div>
            <div className="bg-white w-[90%] lg:w-[462px] px-6 pt-6 pb-4 lg:p-6 shadow-lg rounded-[16px] border-box p-6">
              <p className="text-[#2E3011] text-[24px] font-[600] pb-3">
                AI Note Generation
              </p>
              <p className="mb-4 pt-3 text-[#2E3011] text-[16px] font-[400]">
                This service costs $0.10 per minute of transcription. Your saved card will be charged. <br />
              </p>
              <p className="text-[#103C1B] pb-3 text-[16px] font-[400]">Proceed?</p>

              <div className="flex justify-center gap-4">
                <Button
                  onClick={() => {
                    startAwsScribe({ fileName, appointmentId })
                    setShowAIPricingModal(false);
                    setNoteGenerationStatus("ai-generation");
                  }}
                  additionalClassname="bg-[#103C1B] text-white rounded-md px-4 py-2"
                  label="Yes, proceed"
                />

                <Button
                  onClick={() => {
                    setShowAIPricingModal(false);
                    setNoteGenerationStatus("manual");
                  }}
                  additionalClassname="bg-gray-300 rounded-md px-4 py-2"
                  label="No, use manual"
                />

              </div>
            </div>
          </div>
        </ModalPortal>
      )}

    </>
  );
};

export default Appointments;